module.exports = __webpack_public_path__ + "static/img/s27.cf478813.png";